import { render, staticRenderFns } from "./Commandes.vue?vue&type=template&id=a2a13ea8"
import script from "./Commandes.vue?vue&type=script&lang=js"
export * from "./Commandes.vue?vue&type=script&lang=js"
import style0 from "./Commandes.vue?vue&type=style&index=0&id=a2a13ea8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports